import React from "react";
import {
  useIsAuthenticated,
  useLogout,
  useMenu,
  useNavigation,
  useParsed,
} from "@refinedev/core";
import { Link } from "react-router-dom";
import { useModalForm } from "@refinedev/antd";

import {
  PlusSquareOutlined,
  LogoutOutlined,
  LoginOutlined,
} from "@ant-design/icons";
import { Button, Stack } from "@mui/material";
import AppButton from "components/AppButton";

import { CreateCanvas } from "components/canvas";
import { Canvas } from "types";
import Title from "components/Title";

export const Header: React.FC = () => {
  const { data } = useIsAuthenticated();
  const { mutate: mutateLogout } = useLogout();
  const { push } = useNavigation();
  const { selectedKey } = useMenu();
  const { pathname } = useParsed();

  const { modalProps, formProps, show } = useModalForm<Canvas>({
    resource: "canvases",
    action: "create",
    redirect: "show",
  });

  const isAuthenticated = data?.authenticated;

  const handleRedirect = () => {
    if (!pathname) {
      return push("/login");
    }

    if (pathname === "/") {
      return push("/login");
    }

    push(`/login?to=${encodeURIComponent(pathname)}`);
  };

  return (
    <div className="container">
      <div className="layout-header">
        <Link to="/">
          <Title />
        </Link>
        <Stack flexDirection="row" gap={2}>
          <Link
            to="/"
            className={`nav-button ${selectedKey === "/" ? "active" : ""}`}
          >
            <span className="dot-icon" />
            HOME
          </Link>
          <Link
            to="/canvases"
            className={`nav-button ${
              selectedKey === "/canvases" ? "active" : ""
            }`}
          >
            <span className="dot-icon" />
            NEW
          </Link>
        </Stack>
        <Stack flexDirection="row" gap={2}>
          <AppButton
            startIcon={<PlusSquareOutlined />}
            onClick={() => {
              if (isAuthenticated) {
                show();
              } else {
                handleRedirect();
              }
            }}
            title="Create a new canvas"
            variant="contained"
          >
            Create
          </AppButton>
          {isAuthenticated ? (
            <Button
              onClick={() => {
                mutateLogout();
              }}
              startIcon={<LogoutOutlined />}
              title="Logout"
              variant="contained"
              style={{
                background: "#fa541c",
                color: "white",
                textTransform: "capitalize",
              }}
            >
              Logout
            </Button>
          ) : (
            <AppButton
              onClick={() => {
                handleRedirect();
              }}
              startIcon={<LoginOutlined />}
              title="Login"
              variant="contained"
            >
              Login
            </AppButton>
          )}
        </Stack>
      </div>
      <CreateCanvas modalProps={modalProps} formProps={formProps} />
    </div>
  );
};
